import classNames from 'classnames';
import { FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Vertical)`
  overflow: hidden;

  &.BLOCK.isMyRange {
    background-color: var(--c-brand-600);
  }

  &.ROW {
    &:not(:last-child) {
      border-bottom: 1px solid var(--border-reward-range, var(--c-neutral-200));
      padding-bottom: var(--double-unit);
    }
  }

  &.ROW,
  &.OVERVIEW_ROW {
    background-color: transparent;
    border-radius: 0;
  }
`;
const LeaderboardWrapper = styled.div`
  border-radius: var(--double-unit);
  background-color: rgba(var(--c-rgb-neutral-1000), 0.07);
  backdrop-filter: blur(32px);
  overflow: hidden;
`;
const StyledSBHorizontal = styled(SBHorizontal)`
  min-height: calc(5 * var(--unit));
  flex-wrap: wrap;
`;

export enum RewardRangeVariant {
  OVERVIEW_ROW = 'OVERVIEW_ROW',
  ROW = 'ROW',
  BLOCK = 'BLOCK',
}

type Props = {
  title: ReactNode;
  rewards?: ReactNode[];
  children?: ReactNode;
  isMyRange?: boolean;
  variant: RewardRangeVariant;
};

export const RewardRange: FC<PropsWithChildren<Props>> = ({
  title,
  rewards,
  children,
  isMyRange,
  variant,
}: Props) => {
  return (
    <Root className={classNames(variant, { isMyRange })}>
      <StyledSBHorizontal>
        <div>{title}</div>
        {rewards && <Horizontal>{rewards}</Horizontal>}
      </StyledSBHorizontal>
      {variant === RewardRangeVariant.BLOCK && children && (
        <LeaderboardWrapper>{children}</LeaderboardWrapper>
      )}
    </Root>
  );
};
